import { render, staticRenderFns } from "./VaultSelectFiles.vue?vue&type=template&id=23533e0e&scoped=true&"
import script from "./VaultSelectFiles.vue?vue&type=script&lang=ts&"
export * from "./VaultSelectFiles.vue?vue&type=script&lang=ts&"
import style0 from "./VaultSelectFiles.vue?vue&type=style&index=0&id=23533e0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23533e0e",
  null
  
)

export default component.exports